import { Button } from 'components/Button'
import {
  drinkIcons,
  DrinkIDs,
  drinkSpecs,
} from 'components/MainComponent/drinkSpecs'
import { NumberInput } from 'components/NumberInput'
import { ReactNode, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { polyfill } from 'seamless-scroll-polyfill'

polyfill()
const defaultWeight = 70
export const UserInputs = ({
  lang = 'de',
  colorMode = 'light',
  currentInputs,
  returnInputs,
  // changeParticipation,
  userHasParticipated,
}: {
  lang?: 'de' | 'fr'
  colorMode: 'light' | 'dark'
  currentInputs: { [key: string]: number | string } | undefined
  userHasParticipated: boolean
  // changeParticipation: (val: boolean) => void
  returnInputs: (inp: { [key: string]: number }) => void
}) => {
  const drinktypes = Object.entries(drinkSpecs)
  const drinkicons = drinkIcons
  const [userIsAbstinent, setUserIsAbstinent] = useState(false)
  const [drinkCount, setDrinkCount] = useState<drinkCountType>({
    ...drinktypes.reduce((a, v) => ({ ...a, [v[0]]: 0 }), {} as any),
    weight: defaultWeight,
  })
  const [userHasInteracted, setUserHasParticipated] = useState<boolean>(false)
  const disclaimerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let drinksum = drinkCount
      ? Object.entries(drinkCount)
          .filter(
            (f) => !['weight', 'sum', 'caffeine', 'health'].includes(f[0])
          )
          .reduce((a, v) => a + +v[1], 0)
      : undefined

    if (drinksum === 0) {
    } else {
      userHasInteracted && setUserIsAbstinent(false)
    }
  }, [drinkCount])

  useEffect(() => {
    let userhaschanged =
      [
        ...Object.entries(drinkCount).filter(
          (f) => !['weight', 'sum', 'caffeine', 'health'].includes(f[0])
        ),
      ]
        .map((m) => +m[1])
        .reduce((a, v) => a + v, 0) !== 0

    setUserHasParticipated(userhaschanged || userIsAbstinent)
  }, [drinkCount, userIsAbstinent])

  const handleChange = (id: string, val: number) => {
    val > 0 && setUserHasParticipated(true)
    setDrinkCount({ ...drinkCount, [id]: val })
  }

  const handleChangeAbstinent = (val: boolean) => {
    if (val) {
      // set numbers to zero if user is abstinent

      setDrinkCount({
        ...drinkCount,
        ...drinktypes.reduce((a, v) => ({ ...a, [v[0]]: 0 }), {} as any),
      })
    }
    setUserHasParticipated(true)
    setUserIsAbstinent(val)
  }

  useEffect(() => {
    if (!currentInputs) return
    setDrinkCount(currentInputs as any)
  }, [currentInputs])

  return (
    <>
      <UserInputsRoot>
        <DrinksTitle>
          {lang === 'de' ? (
            <>Wie viel Kaffee trinken Sie am Tag?</>
          ) : (
            <>Combien de café buvez-vous par jour?</>
          )}
        </DrinksTitle>
        <Drinks>
          <>
            {' '}
            {drinktypes
              .sort((a, b) => a[1].quantity - b[1].quantity)
              .map(([drinkid, drinktype], i) => {
                return (
                  <DrinksRow
                    className={'row '}
                    colorMode={colorMode}
                    key={'drinksrow_' + i}
                  >
                    <img src={drinkicons[drinkid]} alt='icon' />
                    <LabelContainer>
                      <Name>
                        {drinktype[lang === 'de' ? 'name_de' : 'name_fr']}
                      </Name>
                      <Description>
                        {drinktype[lang === 'de' ? 'desc_de' : 'desc_fr']}
                      </Description>
                    </LabelContainer>
                    <InputContainer>
                      <NumberInput
                        id={drinkid}
                        startCount={drinkCount[drinkid] as number}
                        onChange={handleChange}
                        maxValue={99}
                        colorMode={colorMode}
                      />
                    </InputContainer>
                  </DrinksRow>
                )
              })}
            <DrinksRow colorMode={colorMode}>
              <img
                src={require('../../assets/icons_nocoffee.png')}
                alt='icon'
              />
              <LabelContainer>
                <Name style={{ fontWeight: 400, flex: '0 0 100%' }}>
                  {lang === 'de' ? (
                    <>Ich trinke keinen oder nur koffeinfreien Kaffee.</>
                  ) : (
                    <>Je ne bois pas de café ou seulement du décaféiné.</>
                  )}
                </Name>
              </LabelContainer>
              <InputContainer>
                <CheckBox
                  checked={userIsAbstinent}
                  setChecked={handleChangeAbstinent}
                >
                  Ich trinke keinen oder nur koffeinfreien Kaffee.
                </CheckBox>
              </InputContainer>
            </DrinksRow>
          </>
        </Drinks>

        <WeightContainer>
          <DrinksTitle>
            {lang === 'de' ? (
              <>Wie viel wiegen Sie?</>
            ) : (
              <>Quel est votre poids?</>
            )}
            <br />
            {lang === 'de' ? (
              <span>
                Bei der Koffeinaufnahme spielt das Gewicht eine Rolle.
              </span>
            ) : (
              <span>L'absorption de la caféine varie en fonction du poids.</span>
            )}
          </DrinksTitle>
          <NumberInput
            inputWidth={100}
            id={'weight'}
            onChange={handleChange}
            startCount={defaultWeight}
            unit='kg'
            minValue={30}
            maxValue={400}
            quickRaise
            colorMode={colorMode}
          />
        </WeightContainer>
        {/* <NoCoffeeContainer>
          <CheckBox
            checked={userIsAbstinent}
            setChecked={handleChangeAbstinent}
          >
            Ich trinke keinen Kaffee.
          </CheckBox>
        </NoCoffeeContainer> */}
        <ButtonContainer>
          <Button
            colorMode={colorMode || 'light'}
            disabled={userHasInteracted}
            onClick={() => {
              const drinkEntries = Object.entries(drinkCount).filter(
                  (f) => !['weight', 'health', 'sum', 'caffeine'].includes(f[0])
                )
              let sum = drinkEntries.reduce((a, v) => a + (+v[1] || 0), 0)
              let caffeine = drinkEntries.reduce((a, v) => {
                  return a + (+v[1] || 0) * (drinkSpecs[v[0] as DrinkIDs]?.caffeine_drink || 0)
                }, 0)
              let health = (+drinkCount.weight || 0) * 5.7

              returnInputs({ ...drinkCount, sum, caffeine, health })
              disclaimerRef.current?.scrollIntoView({ behavior: 'smooth' })
            }}
          >
            {lang === 'de' ? <>Auswerten</> : <>Évaluation</>}
          </Button>
        </ButtonContainer>
      </UserInputsRoot>
      <Disclaimer ref={disclaimerRef}>
        {lang === 'de' ? (
          <>
            Alle Daten werden ausschliesslich für diesen Artikel verwendet. Sie
            werden nicht weitergegeben, sind anonym und werden nicht zu
            persönlichen Daten zugeordnet.
          </>
        ) : (
          <>
            Les données récoltées dans le formulaire sont utilisées
            exclusivement pour cet article. Elles ne sont pas transmises et ne
            sont pas associées à des données personnelles.
          </>
        )}
      </Disclaimer>
    </>
  )
}
//  setUserHasChangedInputs(true)
//
const CheckBox = ({
  children,
  checked = false,
  setChecked,
}: {
  children?: ReactNode
  checked: boolean
  setChecked: (a: boolean) => void
}) => {
  return (
    <CheckboxLabel>
      {/* <span className='label'>{children && children}</span> */}
      <span className='inputcontainer'>
        <input
          type='checkbox'
          onChange={() => {
            setChecked(!checked)
          }}
          checked={checked}
        />
        <span className='checkmark'></span>
      </span>
    </CheckboxLabel>
  )
}

const NoCoffeeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  line-height: 1.4em;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 60px;
`
const CheckboxLabel = styled.label`
  font-size: 15px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span.label {
    display: inline-block;
    width: 100%;
  }
  .inputcontainer {
    display: inline-block;

    width: 100%;
    position: relative;
    &:hover input ~ .checkmark {
      background-color: #ccc;
    }
    input:checked ~ .checkmark {
      background-color: var(--text-color);
    }
    input:checked ~ .checkmark:after {
      display: block;
    }
  }
  .checkmark {
    position: absolute;
    top: 0px;
    right: 10px;
    height: 30px;
    width: 30px;
    background-color: var(--brandblue-bright-5);
    border-radius: 4px;
    &:after {
      content: '';
      position: absolute;
      display: none;
      left: 10.5px;
      top: 5px;
      width: 6px;
      height: 12px;
      border: solid var(--site-background);
      border-width: 0 4px 4px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
`
const Disclaimer = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 12px;
  color: #9698a8;
  line-height: 1.4em;
  margin-top: 30px;
  margin-bottom: 60px;
`
const ButtonContainer = styled.div`
  padding-top: 0px;
  padding-bottom: 30px;
  text-align: center;
`
const UserInputsRoot = styled.div`
  font-family: var(--font-sans-serif);
  margin-top: 60px;
  width: calc(100%);
  background-color: var(--site-background);
  -webkit-box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.05),
    0px 0px 15px 5px rgba(255, 255, 255, 0.1);
  box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.05),
    0px 0px 30px 0px rgba(255, 255, 255, 0.1);
  padding: 15px;
  @media only screen and (max-width: 711px) {
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 0px;
    width: calc(100% - 0px);
  }
`

const InputContainer = styled.div`
  flex: 0 0 120px;
`
const Drinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
`

const DrinksTitle = styled.div`
  width: 100%;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 15px;
  span {
    font-weight: 400;
    font-size: 15px;
    line-height: 2.5em;
  }
`
const DrinksRow = styled.div<{ colorMode: 'light' | 'dark' }>`
  padding-top: 20px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 100%;
  border-bottom: 1px solid
    ${({ colorMode }) =>
      colorMode === 'dark'
        ? 'rgba(255,255,255,.1)'
        : 'var(--brandblue-bright-5)'};
  &.last {
    border-color: ${({ colorMode }) =>
      colorMode === 'dark'
        ? 'rgba(255,255,255,.3)'
        : 'var(--brandblue-bright-1)'};
  }
  &.noBorder {
    border: 0;
  }
  img {
    flex: 0 0 80px;
    max-width: 40px;
    margin-right: 25px;
    margin-left: 15px;
    @media only screen and (max-width: 711px) {
      margin: 0;
      flex: 0 0 30px;
      max-width: 30px;
    }
  }
`
const LabelContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  line-height: 1.1em;
  flex: 0 0 calc(100% - 200px);
  @media only screen and (max-width: 711px) {
    flex: 0 0 calc(100% - 160px);
  }
  div {
    flex: 0 0 100%;
  }
`
const WeightContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  line-height: 1.5em;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 60px;
  @media only screen and (max-width: 711px) {
    line-height: 1.5em;
  }
`

const Name = styled.div`
  font-weight: 700;
  font-size: 18px;
  @media only screen and (max-width: 711px) {
    font-size: 15px;
    line-height: 1.5em;
  }
`
const Description = styled.div`
  font-size: 13px;
  color: var(--coffee-light);
  font-style: italic;
  letter-spacing: 0.2px;
  line-height: 1.6em;
  @media only screen and (max-width: 711px) {
    font-size: 12px;
    line-height: 1.2em;
  }
`
